import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content || "");
};

export default function useSeo({ title, description, image, jsonLd }) {
  useEffect(() => {
    const full = title ? `${title} | Craftendemic` : "Craftendemic - Handmade Leathercraft & Academy";
    document.title = full;
    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", image);
    setMeta("property", "og:type", jsonLd?.["@type"] === "Product" ? "product" : "website");
    let s = document.getElementById("ce-jsonld");
    if (jsonLd) {
      if (!s) { s = document.createElement("script"); s.type = "application/ld+json"; s.id = "ce-jsonld"; document.head.appendChild(s); }
      s.textContent = JSON.stringify({ "@context": "https://schema.org", ...jsonLd });
    } else if (s) s.remove();
  }, [title, description, image, jsonLd]);
}
